var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoga(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m280 296v56l-55.77 40.28-88.23 63.72 24 16v16h-72v-32l95.6-112.47 40.4-47.53z",
    fill: "#ffceb6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m280 296v56l-55.77 40.28-40.63-48.75 40.4-47.53z",
    fill: "#62798c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m256 160h48v64h-48z",
    fill: "#4976f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m256 24h32a16 16 0 0 1 16 16v112h-48z",
    fill: "#ffbfa1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m312 235.8501a29.27685 29.27685 0 0 1 -8.59009 20.73974l-7.40991 7.41016v32h-72v-216l-11.83-17.75a9.16973 9.16973 0 0 1 7.63-14.25h12.2v-8a15.99552 15.99552 0 0 1 16-16h8a15.99548 15.99548 0 0 1 16 16v160l21.57007 8.62988a29.31443 29.31443 0 0 1 18.42993 27.22022z",
    fill: "#ffceb6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m312 235.8501a29.27685 29.27685 0 0 1 -8.59009 20.73974l-7.40991 7.41016v32h-72v-136h48v40l21.57007 8.62988a29.31443 29.31443 0 0 1 18.42993 27.22022z",
    fill: "#548aff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m304 128v32a15.99564 15.99564 0 0 1 -16 16h-16v-80a32.00409 32.00409 0 0 1 32 32z",
    fill: "#ffbfa1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m304 128h-32v-32a32.00409 32.00409 0 0 1 32 32z",
    fill: "#b1712c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m224 184a48 48 0 0 1 -48 48h-8l16-32v-64a40 40 0 0 1 40-40z",
    fill: "#b1712c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m424 472v16h-64l-24-136h-72a40.00186 40.00186 0 0 1 -40-40v-16h136a32.00409 32.00409 0 0 1 32 32v120z",
    fill: "#ffceb6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m320 296v56h-56a40.00186 40.00186 0 0 1 -40-40v-16z",
    fill: "#718799"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoga);
export default __webpack_public_path__ + "static/media/yoga.679e55c880e16cb37c95a851b68d526e.svg";
export { ForwardRef as ReactComponent };